module.exports = __webpack_public_path__ + "img/logo-boe.dd1582a9.jpg";